/*
  LocalStorage wrapper and feature detection
  - http://mathiasbynens.be/notes/localstorage-pattern
  - api:
      setItem(key, value)
      getItem(key)
      removeItem(key)
      clear()
      key(index)
      length
  - does nothing if localStorage isn't supported
*/
module.exports = (function() {

  var self = {},
      storage, isSupported;

  self.init = function() {
    var fail, uid;
    try {
      uid = new Date();
      (storage = window.localStorage).setItem(uid, uid);
      fail = storage.getItem(uid) != uid;
      storage.removeItem(uid);
      fail && (storage = false);
    } catch(e) {}

    isSupported = !!storage;
  };

  /* save object as string */
  self.set = function(key, value) {
    try {
      // Try to save, but catch incase of QuotaExceededError in iOS
      if (isSupported){
        if(typeof value === 'string'){
          storage.setItem(key, value);  
        } else {
          storage.setItem(key, JSON.stringify(value));
        }
      }
    } catch(e) {}
  };

  /* 
    reads and parses string into an object
    returns undefined or the value 
  */
  self.get = function(key) {
    if (isSupported) {
      var value;
      try {
        value = storage.getItem(key);

        if(value) {
          try {
            value = JSON.parse(value);
            return value;
          } catch (e) {
            if(typeof value === 'string') {
              return value;
            } else {
              throw e;
            }
          }
        } else {
          return value;
        }
      } catch(e) {
        if (typeof Airbrake !== 'undefined') {
          Airbrake.push({
            error: e, 
            context: { 
              localStorage: value,
              key: key
            }
          });
        }
      }
    }
  };

  self.remove = function(key) {
    if (isSupported) storage.removeItem(key);
  };

  self.removeItemsWithPrefix = function (prefix) {
    var prefixedKeys = [];
    for (var i = 0; i < storage.length; i++) {
      if (storage.key(i).startsWith(prefix)) {
        prefixedKeys.push(storage.key(i));
      }
    }
    for (var i = 0; i < prefixedKeys.length; i++) {
      storage.removeItem(prefixedKeys[i]);
    }
  }
  self.init();

  return self;

})();